import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import TopBar from "./shared/components/TopBar";
// import MainPage from "./views/MainPage";
import './shared/styles/style.css';
import LocationState from "./app/providers/location/LocationState";
import WorkshopState from "./app/providers/workhsop/WorkshopState";
import WorkshopPage from "./features/workshop/WorkshopPage";
import Footer from "./shared/components/Footer";
import "./i18n";
import ReservationPage from "./features/reservation/ReservationPage";
import { useWindowSize } from "./shared/hooks/useWindowSize";
import FilterState from "./app/providers/filter/FilterState";
import OrderByState from "./app/providers/orderBy/OrderByState";
import ProtectedRoute from "./shared/components/ProtectedRoute";
import Homepage from "./features/dashboard/Homepage";
import CarBrandState from "./app/providers/car-brands/CarBrandState";
import WorkshopList from "./features/workshop/components/WorkshopList";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "./shared/styles/theme";
import { Box } from "@mui/material";
import { Toaster } from 'react-hot-toast';
import AuthInitializer from "./shared/components/AuthInitializer";
import WorkshopOwnerPage from "./features/workshop-owner/WorkshopOwnerPage";
import AdminPage from "./features/admin/AdminPage";

function App() {

  const { isDesktop, isTablet } = useWindowSize();

  return (
    <AuthInitializer>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocationState>
          <WorkshopState>
            <FilterState>
              <OrderByState>
                <CarBrandState>
                  <BrowserRouter>
                    <Box className="App">
                      <TopBar />
                      <Box className={ (isDesktop || isTablet) ? "content-desktop" : "content"}>
                        <Routes>
                          {/* <Route path="/" element={<MainPage />} /> */}
                          <Route path="/" element={<Homepage />} />
                          <Route path="/workshoplist" element={<WorkshopList />} />
                          <Route path="/workshops/:id" element={<WorkshopPage />} />
                          <Route path="/reservations/:reservationUuid" element={<ReservationPage />} />

                          {/* Protected routes below */}
                          <Route path='/workshop-owner/:id' exact element={
                            <ProtectedRoute>
                              <WorkshopOwnerPage />
                            </ProtectedRoute>
                          } />
                          <Route path='/admin/dashboard' exact element={
                            <ProtectedRoute allowedRoles={['admin']}>
                              <AdminPage />
                            </ProtectedRoute>
                          } />
                          <Route path='/admin/edit-workshop/:id' exact element={
                            <ProtectedRoute allowedRoles={['admin']}>
                              <WorkshopOwnerPage />
                            </ProtectedRoute>
                          } />
                          {/* Redirect all unknown routes to "/" */}
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                      </Box>
                      <Box>
                        <Footer />
                      </Box>
                      <Toaster />
                    </Box>
                  </BrowserRouter>
                </CarBrandState>
              </OrderByState>
            </FilterState>
          </WorkshopState>
        </LocationState>
      </ThemeProvider>
    </AuthInitializer>
  );
}

export default App;
